import { createApp } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'

(function () {
  const appContainerSelector = '.friendship-advertisement .vue-app'

  if (!document.querySelector(appContainerSelector)) {
    return
  }

  createApp({
    data () {
      return {
        egkNr: '',
        submitted: false,
        generatedLink: '',
        errorMessage: '',
        loading: false,
        resultsAlreadyGenerated: {}
      }
    },
    setup () {
      return {
        v$: useVuelidate()
      }
    },
    validations () {
      return {
        egkNr: {
          required: helpers.withMessage('Bitte füllen Sie dieses Feld aus.', required),
          validEgkNr: helpers.withMessage('Bitte geben Sie Ihre Versichertennummer 10-stellig im Format A123456789 ein.',
            val => val.length === 10 && val.match(/[a-zA-Z]\d+/)
          )
        }
      }
    },
    methods: {
      focusInput () {
        this.$refs.egkNrInput.focus()
      },
      async submitForm () {
        // validate fields
        this.v$.$touch()

        // abort if validation failed
        if (this.v$.$invalid) {
          return
        }

        // check if the value of egkNr is already a key in the resultsAlreadyGenerated object and if so, abort
        if (this.resultsAlreadyGenerated[this.egkNr]) {
          this.generatedLink = this.resultsAlreadyGenerated[this.egkNr]
          this.submitted = true
          // log the event  (egkNr already generated)
          console.debug('egkNr already generated', this.egkNr, this.resultsAlreadyGenerated[this.egkNr])
          return
        }

        return new Promise(async (resolve, reject) => {
          this.loading = true

          const formData = {
            egkNr: this.egkNr
          }
          const url = '/?type=1500000001'
          const options = {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify(formData)
          }

          const response = await window.fetch(url, options)
          this.loading = false
          this.submitted = true
          if (response.ok) { // if HTTP-status is 200-299
            const data = await response.json()
            this.generatedLink = data.targetPageUrl

            // add the generated link to the resultsAlreadyGenerated object with the egkNr as key
            this.resultsAlreadyGenerated[this.egkNr] = data.targetPageUrl
          } else {
            const data = await response.json()
            console.error('Error while generating link', data)
            this.errorMessage = data.message
            reject(new Error(this.errorMessage))
          }
          resolve()
        })
      },
      // write a function to copy the generated link to the clipboard
      copyLinkToClipboard () {
        // create a temporary input element
        const tempInput = document.createElement('input')
        // set the value of the input element to the generated link
        tempInput.value = this.generatedLink
        // append the input element to the DOM
        document.body.appendChild(tempInput)
        // select the value of the input element
        tempInput.select()
        // copy the selected value to the clipboard
        document.execCommand('copy')
        // remove the input element from the DOM
        document.body.removeChild(tempInput)
      },
      transformInput () {
        this.egkNr = this.egkNr.toUpperCase()
        this.reset()
      },
      reset () {
        // invalidate the generated link and the error message and the validator
        this.errorMessage = ''
        this.v$.$reset()
        this.generatedLink = null
        this.submitted = false
        this.loading = false
      }
    },
    computed: {
      buttonLabel: function () {
        return this.loading ? 'Empfehlungslink wird erstellt...' : 'Empfehlungslink erstellen'
      },
      buttonDisabled: function () {
        return this.loading
      }
    },
    template: `
        <h2 class="friendship-advertisement__headline">Empfehlungslink erstellen</h2>
        <div class="friendship-advertisement__description">
            <img src="/typo3conf/ext/project/Resources/Public/Images/EgkPreview.jpg" class="is--responsive"/>
            <p>Bitte geben Sie Ihre Versichertennummer 10-stellig im Format A123456789, ohne -1/-2, ein.</p>
         </div>
        <form class="friendship-advertisement__form" @submit.prevent="submitForm">
            <label for="egkNr" class="form__label" @click="focusInput">Versichertennummer<span class="form__mandatory">*</span></label>
            <input class="form__input"
                ref="egkNrInput"
                inputmode="text"
                type="text"
                name="egkNr"
                v-model="egkNr"
                @input="transformInput"
                required
            />
            <ul v-if="v$.egkNr.$errors.length" class="errors">
                <li v-for="error in v$.egkNr.$errors">{{error.$message}}</li>
            </ul>
            <div class="button-container text--right">
                <button type="submit" class="btn btn--secondary" :disabled="buttonDisabled">{{buttonLabel}}</button>
            </div>
        </form>
        
        <div ref="resultContainer" class="friendship-advertisement__output">
        
            <Transition name="friendship-advertisement">
              <div v-if="submitted && generatedLink" class="friendship-advertisement__results">
                <h3>Hier ist Ihr Empfehlungslink</h3>
                <div class="link-container"><a :href="generatedLink" title="Ihr Empfehlungslink" target="_blank">{{generatedLink}}</a></div>
                <div class="text--right"><button @click="copyLinkToClipboard" class="btn btn--primary">Link kopieren</button></div>
              </div>
            </Transition>
            
            <Transition name="friendship-advertisement" class="friendship-advertisement__error">
                <p v-if="submitted && errorMessage !== ''">
                    {{errorMessage}}
                </p>
            </Transition>
        </div>
        `
  }).mount(appContainerSelector)
})()
